import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AuthState, LoginRequest } from "../../types/auth.types";
import authService from "../../services/auth/auth.service";
import { SubscriptionStatus } from "../../services/sub/sub.service";
import subService from "../../services/sub/sub.service";

const savedUser = localStorage.getItem('user')
const savedToken = localStorage.getItem('token')
const savedCompanyId = localStorage.getItem('companyId')

interface ExtendedAuthState extends AuthState {
  sub: SubscriptionStatus | null;
  subLoading: boolean;
}

const initialState: ExtendedAuthState = {
  user: savedUser? JSON.parse(savedUser) : null,
  token: savedToken?savedToken:null,
  isAuthenticated: !!savedUser,
  loading: false,
  error: null,
  companyId: savedCompanyId?savedCompanyId:null,
  sub: null,
  subLoading: false,
};

export const login = createAsyncThunk(
  "auth/login",
  async (credentials: LoginRequest, { rejectWithValue }) => {
    try {
      const response = await authService.login(credentials);
      if (response.tokens.accessToken && response.user) {
        authService.setToken(response.tokens.accessToken);
        authService.setUser(response.user);
        localStorage.setItem('companyId', response.user.companyId?.toString() || '');
        return response;
      }

      throw new Error("Giriş başarısız");
    } catch (error: any) {
      return rejectWithValue({
        standartError: {
          message: "Giriş başarısız",
          description: error.response?.data?.error?.description || "Giriş bilgileri hatalı",
          code: error.response?.status || "AUTH_ERROR"
        }
      });
    }
  }
);

export const logout = createAsyncThunk("auth/logout", async () => {
  await authService.logout();
});

export const fetchSubInfo = createAsyncThunk(
  'auth/fetchSubInfo',
  async (companyId: number, { rejectWithValue }) => {
    try {
      const subInfo = await subService.getSubsByCompanyId();
      if (!subInfo) {
        return null;
      }
      return subInfo; // API direkt obje döndürüyor
    } catch (error: any) {
      return rejectWithValue(error.message || 'Sub bilgileri alınamadı');
    }
  }
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    checkAuth: (state) => {
      const token = authService.getToken();
      const user = authService.getUser();
      const companyId = localStorage.getItem('companyId');
      state.isAuthenticated = !!token;
      state.token = token;
      state.user = user;
      state.companyId = companyId?companyId:null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(login.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(login.fulfilled, (state, action) => {
        state.loading = false;
        state.isAuthenticated = true;
        state.user = action.payload.user;
        state.token = action.payload.tokens.accessToken;
        state.error = null;
      })
      .addCase(login.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })
      .addCase(logout.fulfilled, (state) => {
        state.user = null;
        state.token = null;
        state.isAuthenticated = false;
        state.error = null;
        state.sub = null;
      })
      .addCase(fetchSubInfo.pending, (state) => {
        state.subLoading = true;
      })
      .addCase(fetchSubInfo.fulfilled, (state, action) => {
        state.subLoading = false;
        state.sub = action.payload as unknown as SubscriptionStatus;
      })
      .addCase(fetchSubInfo.rejected, (state) => {
        state.subLoading = false;
      });
  },
});

export const { clearError, checkAuth } = authSlice.actions;
export default authSlice.reducer;
